module.exports = __webpack_public_path__ + "static/img/coupon-btn.109f253.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coupon-btn.png
// module id = ELNE
// module chunks = 1